export default __webpack_public_path__ + "static/media/Elle_Tiffany_2021_04_211189.3ef59dd8.gif";